import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { downloadCSV } from '@frontend/media-helpers';

const EMAIL_CSV_EXAMPLE_NAME = 'email-recipient-list-example';
const EMAIL_CSV_EXAMPLE_CONTENT = `
First Name,Last Name,Email,Preferred Name
John,Doe,john.doe@example.com,John
Tony,Dow,tony.dow@example.com,Homer
Bruce,Nolan,bruce.nolan@example.com,Bruce
Samuel,Zabaglione,samuel.zabaglione@example.com,Sam
`.trim();

const TEXT_CSV_EXAMPLE_NAME = 'text-recipient-list-example';
const TEXT_CSV_EXAMPLE_CONTENT = `
First Name,Last Name,Phone,Preferred Name
John,Doe,555-555-5555,John
Anthony,Dow,6365553226,Tony
Christopher,Nolan,1-716-776-2323,Chris
Samuel,Zabaglione,(555) 755-2099,Sam
`.trim();

export const downloadExampleCsv = (campaignType: CampaignType) => {
  if (campaignType === CampaignType.SMS) {
    downloadCSV(TEXT_CSV_EXAMPLE_CONTENT, TEXT_CSV_EXAMPLE_NAME);
  } else {
    downloadCSV(EMAIL_CSV_EXAMPLE_CONTENT, EMAIL_CSV_EXAMPLE_NAME);
  }
};
